import React, { useEffect } from "react";

import { CurrentStoryContext } from "~utils/currentStoryContext";
import getArticleMetadata from "~utils/getArticleMetadata";

declare const window: Window &
    typeof globalThis & {
        __bloomberg__: any;
    };

export default function AbbaMetadataScript() {
    const context = React.useContext(CurrentStoryContext);
    const articleMetadataObject = getArticleMetadata(context?.story);

    useEffect(() => {
        if (window?.__bloomberg__?.setContentMetadata) {
            window.__bloomberg__.setContentMetadata(articleMetadataObject);
        }
    }, []);

    return null;
}
